import { render, staticRenderFns } from "./select-tech-part.vue?vue&type=template&id=72c8375a&scoped=true"
import script from "./select-tech-part.vue?vue&type=script&lang=js"
export * from "./select-tech-part.vue?vue&type=script&lang=js"
import style0 from "./select-tech-part.vue?vue&type=style&index=0&id=72c8375a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8375a",
  null
  
)

export default component.exports